// extracted by mini-css-extract-plugin
module.exports = {"headlineMedium":"styles_headlineMedium__3u3r3","alignCenter":"styles_alignCenter__2l6eo","alignLeft":"styles_alignLeft__kSjZO","alignRight":"styles_alignRight__3VTCF"};